<div class="app-modal-title">Select layers to restore</div>
<div class="app-modal-content">
	<div class="layer-list">
		<div class="layer-item" *ngFor="let layer of layers; let idx = index;">
			<input name="select-{{idx}}" type="checkbox" [(ngModel)]="layer.isSelected">
			<label>{{layer.code}}</label>
		</div>
	</div>
</div>
<div class="app-modal-footer">
	<div class="button-group">
		<button class="button-general" md-raised-button (click)="cancel()">Cancel</button>
		<button class="button-general" md-raised-button (click)="restore()">Restore</button>
	</div>
</div>